import { useMemo, useState } from 'react';
import IconAdd from '../images/IconAdd.jsx';
import BaseInput from '../form/BaseInput.jsx';
import IconRemove from '../images/IconRemove.jsx';
import BaseDropdown from '../form/BaseDropdown.jsx';
import IconCancel from '../images/IconCancel.jsx';
import IconSave from '../images/IconSave.jsx';
import { useGetSocialMediaTypesQuery } from '../../api/misc.js';

const SocialLinks = ({ addNew = false, fields, append, control, clearErrors, remove }) => {
    const { data: socialMediaTypes } = useGetSocialMediaTypesQuery({});

    const [socialLink, setSocialLink] = useState({
        type: '',
        url: ''
    });
    const [addNewSocialLink, setAddNewSocialLink] = useState(addNew);

    const socialOptions = useMemo(() => {
        if (socialMediaTypes?.response?.social_media_types) {
            return socialMediaTypes.response.social_media_types;
        }

        return [];
    }, [socialMediaTypes]);

    const cancelAddSocial = () => {
        setAddNewSocialLink(false);
        setSocialLink({
            type: '',
            url: ''
        });
    };

    const saveSocial = () => {
        if (socialLink.type !== '' && socialLink.url !== '') {
            append({
                type: socialLink.type,
                url: socialLink.url
            });

            setAddNewSocialLink(false);
            setSocialLink({
                type: '',
                url: ''
            });
        }
    };

    return (
        <>
            <div className='mb-4 text-theme1-primary font-bold text-xl flex justify-between'>
                <span>Social Media Links</span>
                <span className='cursor-pointer' onClick={() => setAddNewSocialLink(true)}>
                    <IconAdd className='fill-theme1-text1' />
                </span>
            </div>
            <div className='mb-10'>
                {fields.length > 0 && (
                    <>
                        {fields.map((social_link, index) => {
                            return (
                                <div key={social_link.id} className='w-full flex'>
                                    <div className='flex-grow'>
                                        <BaseInput
                                            className='mb-4'
                                            labelClassName='text-theme1-primary'
                                            type='text'
                                            control={control}
                                            label={socialOptions.find((obj) => obj.value === social_link.type)?.label}
                                            placeholder='https://...'
                                            name={`social_links[${index}].url`}
                                            clearErrors={clearErrors}
                                            errors={[]}
                                        />
                                    </div>
                                    <div className='ml-4 cursor-pointer' onClick={() => remove(index)}>
                                        <IconRemove className='mt-8 fill-theme1-border1' />
                                    </div>
                                </div>
                            );
                        })}
                    </>
                )}

                {addNewSocialLink && (
                    <>
                        <BaseDropdown
                            className='mt-4'
                            value={socialLink.type}
                            label='Choose media type'
                            name='type'
                            setValue={(value) => setSocialLink({ ...socialLink, type: value })}
                            options={socialOptions}
                        />
                        <BaseInput
                            className='mt-4'
                            type='text'
                            value={socialLink.url}
                            label='Paste your url here'
                            placeholder='https://...'
                            name='url'
                            setValue={(value) => setSocialLink({ ...socialLink, url: value })}
                        />
                        <div className='flex justify-end items-center mt-2'>
                            <div className='mr-4' onClick={cancelAddSocial}>
                                <IconCancel className='fill-theme1-border1' />
                            </div>
                            <div onClick={saveSocial}>
                                <IconSave className='fill-theme1-border1' />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default SocialLinks;
